import { render, staticRenderFns } from "./youthList.vue?vue&type=template&id=96ec750a&scoped=true&"
import script from "./youthList.vue?vue&type=script&lang=js&"
export * from "./youthList.vue?vue&type=script&lang=js&"
import style0 from "./youthList.vue?vue&type=style&index=0&id=96ec750a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96ec750a",
  null
  
)

export default component.exports